import React from 'react'

// Props.
interface Props {
  anchor: string
  children: React.ReactNode | React.ReactNodeArray
}

// Share Event Modal.
export const PageAnchor: React.FC<Props> = (props) => {
  // Props
  const { anchor, children } = props

  return <div id={generatePageAnchor(anchor)}>{children || null}</div>
}

export const generatePageAnchor = (anchor: string) => {
  return `go-to-${anchor}`
}
